import React from 'react';
import { Badge, useComputedColorScheme } from '@mantine/core';
import { modals } from '@mantine/modals';
import type { SelectedOperation } from '~/server/logic/prisma/operation-select';
import { TimeoutOverrideFormModal } from '../../TimeoutOverrideFormModal';
import { IconClock } from '@tabler/icons-react';

export default function TimeoutPart({
  timeoutMs,
  operation,
  testContentId,
  readonly,
}: {
  timeoutMs: number;
  operation: SelectedOperation;
  testContentId: string;
  readonly?: boolean;
}) {
  const colorScheme = useComputedColorScheme();

  // Convert milliseconds to seconds for display
  const timeoutSeconds = timeoutMs / 1000;

  const handleDoubleClick = () => {
    if (readonly) {
      return;
    }

    modals.open({
      title: 'Override Timeout',
      centered: true,
      children: (
        <TimeoutOverrideFormModal
          operation={operation}
          testContentId={testContentId}
        />
      ),
    });
  };

  return (
    <div className="flex items-center gap-2">
      <Badge
        size="sm"
        variant="light"
        color={colorScheme === 'dark' ? 'blue' : 'blue'}
        className="font-mono normal-case"
        onDoubleClick={handleDoubleClick}
        style={{ cursor: readonly ? 'default' : 'pointer' }}
      >
        <div className="flex items-center gap-1">
          <IconClock size={12} />
          <span>{timeoutSeconds}s</span>
        </div>
      </Badge>
    </div>
  );
}
